import { ThemeDefinition } from './types';
import { WEAPONS_THEME } from './WeaponsTheme';
import { PHILOSOPHY_THEME } from './PhilosophyTheme';

export const THEMES: ThemeDefinition[] = [
  PHILOSOPHY_THEME,
];

export { PHILOSOPHY_THEME };
